import {
   Component, Input, OnInit, ViewChild, Output, EventEmitter, HostListener
} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {DragulaService} from 'ng2-dragula';
import {FlowComponent} from '../../view-flow/flow/flow.component';
import {IdexService} from 'app/idex.service';
import {EditActionComponent} from '../edit-action/edit-action.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../../shared/toast/toast';
import { TaskAttribute } from '../../create-task/create-task.type';
import { EformService } from 'app/e-form/service/eform.service';

let isColumn;

@Component({
   selector: 'app-flow-recipients',
   templateUrl: './flow-recipients.component.html',
   styleUrls: ['./flow-recipients.component.css']
})
export class FlowRecipientsComponent implements OnInit {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() show = true;
   @Output() workflowIdChange = new EventEmitter<any>();
   @ViewChild(FlowComponent)
   public flow: FlowComponent;
   @ViewChild('menuContext')
   public menuCont;
   private editActionDialog: MatDialogRef<EditActionComponent>;

   public test;
   public apvLevel = [];
   isExpanded = true;
   id: number;
   errorMessage: any;
   rightPanelStyle: Object = {};
   emailList: string[] = [];
   selectNumOfSigner: any;

   @Output() clickOutside = new EventEmitter<MouseEvent>();
   public addActionClick;
   public items = [];
   public groups = [];
   public numOfSigner;
   public order;
   public workflowId;
   dragCol: boolean;
   isDrag = true;

   private _indexStart;
   subs = new Subscription();
   BAG = 'item-bag';
   GROUP = 'group_bag';
   stepOrder = 0;
   ischeckSignItem = true;
   uniqueRef: string;
   counter = 0;

   constructor(private dragulaService: DragulaService,
               public service: IdexService,
               private dialog: MatDialog,
               public toast: Toast,
               public translate: TranslateService,
               private eFormService: EformService) {
      var that = this;
      this.addActionClick = new Subject();
      const bag: any = this.dragulaService.find(this.GROUP);
      if (bag !== undefined) {
         this.dragulaService.destroy(this.GROUP);
      }
      dragulaService.createGroup(this.GROUP, {
         invalid(el, handle) {
            if (typeof el.className === 'string') {
               if (el.className.includes('box-item')) {
                  isColumn = true;
               } else {
                  isColumn = false;
               }
               return (el.className.includes('box-item'));
            }
         }
      });
      dragulaService.drop(this.BAG).subscribe((value: any) => {
         this.addClass(value, 'ex-moved');
         this.onDrop(value);
      });
      dragulaService.dragend(this.GROUP).subscribe((value) => {
         for (let index = 0; index < this.taskAttribute.apvLevel.length; index++) {
            this.taskAttribute.apvLevel[index].order = index + 1;
         }
      });
      dragulaService.drop().subscribe(({ name }) => {
         this.isDrag = true;
         this.dragulaService.find(name).drake.cancel(true);
      });
      dragulaService.drop(this.GROUP).subscribe((value: any) => {
         this.isDrag = true;
         this.onDrop(value);
      });

      dragulaService.dropModel().subscribe(async ({ target, item}) => {
         if (target.id) { /// ตรวจสอบกล่อง item ลายเซ็นห้ามคนเดียวกันอยู่ในระดับเดียวกัน
            that.ischeckSignItem = true;
           try {
            const elements = document.querySelectorAll('#' + target.id);
            const arr_mailCheckElement = [];
            let mailCheckElement;
             if (elements.length > 0) {
               const firstElement = elements[0];
               const itemBox = document.getElementById(firstElement.id);
               const parts = itemBox.getAttribute('id').split('-');
               const numericPart = parseInt(parts[parts.length - 1], 10);
               const selector = `[id^="box-item-${numericPart}"]`;
               const childElements = itemBox.querySelectorAll(selector);
               for (let i = 0; i < childElements.length; i++) {
                  mailCheckElement = childElements[i].querySelector('span');
                  arr_mailCheckElement.push(mailCheckElement.innerText);
                  if (numericPart !== item.stepOrder) {
                     if (mailCheckElement.innerText === item.signerEmail) {
                        that.isDrag = false;
                        that.ischeckSignItem = false;
                        break;
                     } else {
                        that.ischeckSignItem = true;
                     }
                  } else {
                     that.ischeckSignItem = false;
                  }
               }
             }
           } catch (error) {
             this.errorMessage = error;
             this.toast.error(error);
           }
         }
      });

      this.isChangeFlowRecipientData();
   }

   private isChangeFlowRecipientData() {
      this.eFormService.changeFlowRecipientData.subscribe(data => {
         if (data) {
            this.eFormService.changeFlowRecipientTrigger.next([]);
         }
      });
   }

   public setApvLevel() { /// ZE-3303 [EWG] - Add user เดิมใน flow ได้ แต่ต้องคนละ level
      // if (this.ischeckSignItem) { // check status Duplicate Items
         var signerMap = new Map();
         for (const apvLevel of this.taskAttribute.apvLevel) {
            const apvStepOrder = parseInt(apvLevel.order, 10);
            for (const signer of apvLevel.signerList) {
               signer.stepOrder = apvStepOrder;
               signerMap.set(parseInt(signer.taskContactId, 10), apvStepOrder);
            }
         }

         if (this.taskAttribute.docList) {
            for (const doc of this.taskAttribute.docList) {
               if (doc.signItems) {
                  for (const signItem of doc.signItems) {
                     const docContactId = parseInt(signItem.taskContactId, 10);
                     signItem.stepOrder = signerMap.get(docContactId);
                  }
               }
            }
         }
      // }
   }

   ngOnInit() {
      this.handleAddActionClick();
   }

   setExpand(isExpand: boolean) {
      this.isExpanded = isExpand;
   }

   @HostListener('document:click', ['$event', '$event.target'])
   public onClick(event: MouseEvent, targetElement: HTMLElement): void {
      const menuCont = document.getElementsByClassName('rightClickPanel');
      for (let i = 0; i < menuCont.length; i++) {
         menuCont[i].setAttribute('style', 'display:none');
      }
   }

   handleAddActionClick() {
      const addActionClick = this.addActionClick
         .subscribe((object) => {
            this.items = [];
            this.uniqueRef = this.generateUniqueId();
            const inputName = object.inputInserted.name === undefined ? object.inputInserted : object.inputInserted.name;
            const inputType = object.typeSelected;
            const inputAction = object.actionSelected;
            let inputEmail = object.emailInserted.email === undefined ? object.emailInserted : object.emailInserted.email;
            inputEmail = inputEmail.toLowerCase();
            let action;
            switch(inputAction) {
               case 'NS' :{
                  action = 'Need to Sign';
                  break;
               }
               case 'ES': {
                  action = 'External Sign';
                  break;
               }
               default: {
                  action = 'CC';
                  break;
               }
            }
            this.isExpanded = true;
            const veriFiedLv = object.verifiedLvInserted;
            if (inputType === 'person') {
               const index = inputName.indexOf(' ');
               let nShow = inputName;

               if (index > -1) {
                  const lastName = inputName.length >= index + 2 ? ' ' + inputName.substring(index + 1, index + 2) + '.' : '';
                  nShow = inputName.substring(0, index) + lastName;
               }
               this.errorMessage = '';
               this.items.push({
                  nameShow: nShow,
                  signerName: inputName,
                  action: action,
                  signerEmail: inputEmail,
                  verifiedLv: veriFiedLv,
                  stepOrder: this.taskAttribute.apvLevel.length + 1,
                  taskContactId: this.uniqueRef
               });

               this.emailList.push(inputEmail);

               this.taskAttribute.apvLevel.push({
                  signerList: this.items,
                  order: this.taskAttribute.apvLevel.length + 1,
                  numOfSigner: 0
               });
               object.filteredOptions = undefined;
               object.inputInserted = '';
               object.emailInserted = '';
               object.typeSelected = inputType;
               object.actionSelected = inputAction;
            } else {
               this.errorMessage = '';
               const contList = '';
               const groupId = object.groupInserted;
               if (groupId !== undefined) {
                  this.service.getContactInGroup(groupId)
                     .subscribe((data: any) => {
                        for (let i = 0; i < data.length; i++) {
                           const contactName = data[i].fullName;
                           const index = contactName.indexOf(' ');
                           let nShow = contactName;
                           if (index > 0) {
                              const lastName = contactName.length >= index + 2 ? ' ' +
                                 contactName.substring(index + 1, index + 2) + '.' : '';
                              nShow = contactName.substring(0, index) + lastName;
                           }
                           this.items.push({
                              nameShow: nShow,
                              signerName: contactName,
                              action: action,
                              signerEmail: data[i].email,
                              verifiedLv: data[i].verifiedLv,
                              stepOrder: this.taskAttribute.apvLevel.length + 1,
                              taskContactId: this.generateUniqueId()
                           });
                           this.emailList.push(data[i].email);
                        }

                        if (data.length <= 0) {
                           this.translate.get('main.useringroup-not-found').subscribe(s => {
                              this.errorMessage = s;
                              this.toast.error(s);
                           });
                        } else if (contList !== '') {
                           this.translate.get('alert.duplicate_contactlist').subscribe(s => {
                              this.errorMessage = s + contList;
                           });
                        }
                        if (this.items.length > 0) {
                           const item = {
                              signerList: this.items,
                              order: this.taskAttribute.apvLevel.length + 1,
                              numOfSigner: 0
                           };
                           this.taskAttribute.apvLevel.push(item);
                        }
                        object.inputInserted = '';
                        object.emailInserted = '';
                        object.typeSelected = inputType;
                        object.actionSelected = inputAction;
                     }, error => {
                        this.translate.get('main.group-not-found').subscribe(s => {
                           this.errorMessage = s;
                           this.toast.error(s);
                        });
                     });
               }
            }
         });
   }

   getListSigner(signerList: any, index: any) {
      const noSignerList: number[] = [];
      if (signerList !== null && signerList !== undefined) {
         let loop = 0;
         for (let i = 0; i < signerList.length; i++) {
            if (this.emailList.indexOf(signerList[i].signerEmail) < 0) {
               this.emailList.push(signerList[i].signerEmail);
            }

            if (signerList[i].action.toLowerCase() === 'need to sign' || signerList[i].action.toLowerCase() === 'external sign') {
               noSignerList[loop] = loop + 1;
               loop++;
            }
         }
      }

      if (this.taskAttribute.apvLevel[index].numOfSigner > noSignerList.length) {
         this.taskAttribute.apvLevel[index].numOfSigner = 0;
      }

      return noSignerList;
   }

   addOrder() {
      this.items = [];
      this.items.push({
         nameShow: '',
         signerName: '',
         action: '',
         signerEmail: '',
         verifiedLv: '',
         taskContactId: 0
      });
      this.taskAttribute.apvLevel.push({
         signerList: this.items,
         order: this.taskAttribute.apvLevel.length + 1,
         numOfSigner: 0
      });
   }

   generateUniqueId() {
      const timestamp = new Date().getTime();
      const uniqueId = `${timestamp}${this.counter}`;
      this.counter++;
      return uniqueId;
   }

   deleteGroup(i: number) {
      const indexSignList = this.taskAttribute.apvLevel[i].signerList.length;
      this.eFormService.removeGroup.next(true);
      for (let j = 0; j < indexSignList; j++) {
         this.deleteSignItemsInDocList(i, j);
         const index = this.emailList.indexOf(this.taskAttribute.apvLevel[i].signerList[j].signerEmail); // email delete
         if (index > -1) {
            this.emailList.splice(index, 1);
         }
      }
      this.taskAttribute.apvLevel.splice(i, 1);
      const indexApvLV = this.taskAttribute.apvLevel.length;
      for (let j = 0; j < indexApvLV; j++) {
         this.taskAttribute.apvLevel[j].order = j + 1;
         for (let i = 0; i < this.taskAttribute.apvLevel[j].signerList.length; i++) {
            this.taskAttribute.apvLevel[j].signerList[i].stepOrder = j + 1;
         }
      }
   }

   deleteWFContact(i: number, k: number, signerEmail: string) {
      const index = this.emailList.indexOf(signerEmail);

      if (index > -1) {
         this.emailList.splice(index, 1);
      }
      this.deleteSignItemsInDocList(i, k);
      this.taskAttribute.apvLevel[i].signerList.splice(k, 1);

      if (this.taskAttribute.apvLevel[i].signerList.length === 0) {
         this.taskAttribute.apvLevel.splice(i, 1);
         for (let count = 0; count < this.taskAttribute.apvLevel.length; count++) {
            this.taskAttribute.apvLevel[count].order = count + 1;
            for (let j = 0; j < this.taskAttribute.apvLevel[count].signerList.length; j++) {
               this.taskAttribute.apvLevel[count].signerList[j].stepOrder = count + 1;
            }
         }
      }
      //todo
   }

   deleteSignItemsInDocList(indexGroup, indexSigner) {
      for (let l = 0; l < this.taskAttribute.docList.length; l++) {
         if (this.taskAttribute.docList[l].signItems) {
            for (let k = 0; k < this.taskAttribute.docList[l].signItems.length; k++) {
               const signerFlow = this.taskAttribute.apvLevel[indexGroup].signerList[indexSigner].signerEmail.toLowerCase();
               const signerId = parseInt(this.taskAttribute.apvLevel[indexGroup].signerList[indexSigner].taskContactId, 10);
               const fieldType = this.taskAttribute.docList[l].signItems[k].fieldType;
               if (signerId === parseInt(this.taskAttribute.docList[l].signItems[k].taskContactId, 10)) {
                  const fieldSigner = this.taskAttribute.docList[l].signItems[k].signer;
                  let senderEmail = this.service.user.email;
                  if (this.taskAttribute.senderEmail) {
                     senderEmail = this.taskAttribute.senderEmail;
                  }
                  if ((fieldType !== 'comment') || (fieldType === 'comment' &&  signerFlow === fieldSigner && signerFlow !== senderEmail.toLowerCase())) {
                     this.taskAttribute.docList[l].signItems.splice(k, 1);
                     k--;
                  }
               }
            }
         }
      }
   }

   detectRightMouseClick($event, rightPanel: any) {
      if ($event.which === 3 && !this.taskAttribute.viewMode) {
         const menuCont = document.getElementsByClassName('rightClickPanel');
         for (let i = 0; i < menuCont.length; i++) {
            menuCont[i].setAttribute('style', 'display:none');
         }

         rightPanel.style.display = 'block';
         rightPanel.style.left = ($event.offsetX + 20) + 'px';
         rightPanel.style.top = ($event.offsetY + 15) + 'px';
         return false;
      }
   }

   closeContextMenu(rightPanel: any) {
      rightPanel.style.display = 'none';
   }

   editAction(i: number, k: number, action: string) {
      this.editActionDialog = this.dialog.open(EditActionComponent, {
         disableClose: true,
         data: this
      });
      this.editActionDialog.componentInstance.actionSelected = this.toActionCode(action);
      this.editActionDialog.afterClosed().subscribe(result => {
         if (result !== '' && result !== undefined) {
            const newAction = this.toActionName(result);
            // Need to Sign <-> External Sign เก็บตำแหน่งลายเซ็นเดิมไว้ ลบเฉพาะกรณีเปลี่ยนเป็น CC
            if (newAction === 'CC' && action !== 'CC') {
               this.deleteSignItemsInDocList(i, k);
            }
            this.taskAttribute.apvLevel[i].signerList[k].action = newAction;
         }
      });
   }

   private toActionCode(action: string): string {
      switch (action) {
         case 'Need to Sign': return 'NS';
         case 'External Sign': return 'ES';
         default: return 'CC';
      }
   }

   private toActionName(code: string): string {
      switch (code) {
         case 'NS': return 'Need to Sign';
         case 'ES': return 'External Sign';
         default: return 'CC';
      }
   }

   private hasClass(el: any, name: string): any {
      return new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)').test(el.className);
   }

   private addClass(el: any, name: string): void {
      if (!this.hasClass(el, name)) {
         el.className = el.className ? [el.className, name].join(' ') : name;
      }
   }

   private removeClass(el: any, name: string): void {
      if (this.hasClass(el, name)) {
         el.className = el.className.replace(new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)', 'g'), '');
      }
   }

   private onDrag(args: any): void {
      const [e] = args;
      this._indexStart = this.getElementIndex(args);
      this.removeClass(args, 'ex-moved');
   }

   public onDrop(value): void {
      const index = this.taskAttribute.apvLevel.length;
      for (let i = 0; i < index; i++) {
         if (this.taskAttribute.apvLevel[i].signerList.length === 0) { // delete when drop other row and now have signer in row
            this.taskAttribute.apvLevel.splice(i, 1);
            if (value.el && value.target.contains(value.el)) {
               value.target.removeChild(value.el);
            }
            break;
         }
      }
      for (let count = 0; count < this.taskAttribute.apvLevel.length; count++) { // sort new order
         this.taskAttribute.apvLevel[count].order = count + 1;
      }
      this.setApvLevel();
   }

   private onOver(args: any): void {
      const [el] = args;
      this.addClass(args, 'ex-over');
   }

   private onOut(args: any): void {
      const [el] = args;
      this.removeClass(args, 'ex-over');
      this.removeClass(args, 'ex-moved');
      const index = this.taskAttribute.apvLevel.length;
      for (let i = 0; i < index; i++) {
         this.taskAttribute.apvLevel[i].order = i + 1;
      }
   }

   private getElementIndex(el: any) {
      return [].slice.call(el.parentElement.children).indexOf(el); // get index of target HTML object
   }

   onFlowChange(id) {

      this.workflowIdChange.emit(id);
      this.isExpanded = true;
   }

}
